/**
 * Contextual prompt line + an Interact button that appears only when the sim
 * reports something operable nearby. The button is the interact edge source.
 */
export interface PromptHud {
  /** Show a prompt line, or null to hide. `bubble` styles it as a callout. */
  setPrompt(text: string | null, bubble?: boolean): void;
  showInteract(show: boolean, label?: string): void;
  dispose(): void;
}

export function createPromptHud(parent: HTMLElement, onInteract: () => void): PromptHud {
  const prompt = document.createElement('div');
  prompt.className = 'prompt-hud';

  const btn = document.createElement('button');
  btn.className = 'interact-btn';
  btn.textContent = 'OPERATE';
  btn.hidden = true;
  btn.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    onInteract();
  });

  parent.appendChild(prompt);
  parent.appendChild(btn);

  return {
    setPrompt(text, bubble = false) {
      if (text) {
        prompt.textContent = text;
        prompt.classList.add('visible');
        prompt.classList.toggle('bubble', bubble);
      } else {
        prompt.classList.remove('visible');
        prompt.classList.remove('bubble');
      }
    },
    showInteract(show, label = 'OPERATE') {
      btn.textContent = label;
      btn.hidden = !show;
    },
    dispose() {
      prompt.remove();
      btn.remove();
    },
  };
}
